import { Timeline } from '@mui/lab'
import { styled } from '@mui/material'

export const Container = styled(Timeline)`
  & .MuiTimelineItem-root::before {
    flex: 0;
    padding: 0;
  }
  > li:last-child {
    & > div {
      padding-bottom: 0;
    }
  }

  flex: 0;
  margin: 0;
  padding-bottom: ${({ theme }) => theme.spacing(3)};
`
